import { render, staticRenderFns } from "./MedicalRecords.vue?vue&type=template&id=7ca830f4"
import script from "./MedicalRecords.vue?vue&type=script&lang=js"
export * from "./MedicalRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports